// src/PatronLimitModal.js
import React from "react";
import "./PatronLimitModal.css";

const PatronLimitModal = ({
  isOpen,
  onClose,
  organizationName,
  patronLimit,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="patron-limit-modal-overlay" onClick={onClose} />
      <div className="patron-limit-modal">
        <div className="patron-limit-modal-header">
          <h2>Patron Limit Reached</h2>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="patron-limit-modal-content">
          <div className="patron-limit-icon">⚠️</div>
          <p className="patron-limit-message">
            <strong>{organizationName}</strong> has reached the maximum limit of{" "}
            <strong>{patronLimit} patrons</strong> per organization.
          </p>
          <p className="patron-limit-suggestion">
            To add a new patron, please delete an existing patron first or
            contact support to increase your organization's patron limit.
          </p>
        </div>
        <div className="patron-limit-modal-actions">
          <button className="patron-limit-ok-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </>
  );
};

export default PatronLimitModal;
